<template>
	<div class="speed-share-message">
		<div v-if="messageType == 1" class="share-message-wrap">
			<div class="white-wrap">
				<div class="text1">很抱歉</div>
				<div class="text2">该设备暂不支持小宝积分</div>
				<div class="icon"></div>
				<div class="text3">您可使用带有存储功能的设备开启小宝积分</div>
			</div>
		</div>
	</div>
</template>

<script>
import Message from "@/components/Message.vue";

export default {
	components: {
		Message,
	},
	props: {
		messageType: Number,
	},

	data: function () {
		return {};
	},
	methods: {},
	mounted() {
		let _that = this;
	},
};
</script>

<style scoped lang="less">
.speed-share-message {
	font-size: 12px;
	color: #666666;

	.bg {
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.share-message-wrap {
		position: absolute;
		top: 54px;
		left: 163px;
		bottom: 18px;
		z-index: 9;
		width: 915px;
		// height: 100%;
		background-color: rgba(81, 81, 81, 0.35);

		.white-wrap {
			position: absolute;
			padding-top: 1px;
			right: 40px;
			top: 50px;
			width: 345px;
			height: 450px;
			background-color: #f5f5f5;
			border-radius: 7px;
			box-sizing: border-box;
			box-shadow: 0px 0px 5px 2px rgba(193, 193, 193, 0.5);
			overflow: hidden;
			text-align: center;

			.text1 {
				margin-top: 53px;
				font-size: 20px;
				font-weight: 700;
				color: #666666;
			}
			.text2 {
				margin-top: 10px;
				font-size: 14px;
				color: #e23e20;
			}
			.icon {
				margin: 0 auto;
				margin-top: 30px;
				width: 221px;
				height: 210px;
				.bg();
				background-image: url("../assets/speedShare/a3.png");
			}
			.text3 {
				margin-top: 20px;
				font-size: 14px;
				color: #666666;
			}
		}
	}
}
</style>
